const Symbol = {
  DEVOURER: "&",
  BLADE_1: "/",
  BLADE_2: "\\",
  REAVER_1: "{",
  REAVER_2: "}",
  RIFT_1: "-",
  RIFT_2: "~",
  SPECTRE_1: "(",
  SPECTRE_2: ")",
  VOID_HORZ_1: "<",
  VOID_HORZ_2: ">",
  VOID_VERT_1: "^",
  VOID_VERT_2: "v",
  RESIDUE: "_",

  TAPESTRY: "1",
  ARCHIVE: "2",
  BESTIARY: "3",
  WARDROBE: "4",
  ARSENAL: "5",
  GIZMOS: "6",
  COMMON_FINDS: "7",
  MYTHIC_FINDS: "8",

  BLANK: " ",
  ARMAMENT: "e",
  BINDER: "b",
  HINT: "h",
  COLLECTIBLE_COMMON: "c",
  COLLECTIBLE_MYTHIC: "C",
  GIZMO: "g",
  ITEM: "i",
  KEY: "k",
  OPTIC: "o",
  PLAYER: "@",
  PIGMENT: "p",
  PIGMENT_DROP: "P",
  PORTAL: "O",
  ELIXIR: "x",
  UNKNOWN: "?",
  WEARABLE: "e",
  LOCKED_DOOR: "x",

  ERROR_1: "ã",
  ERROR_2: "ä",
}

export { Symbol }
